<template>
  <div class="dashboard-container">
    <side-bar />
    <div class="main-content">
      <h2>New Customer Sign-Up</h2>
      <hr class="h2"/>
      <div class="container">
        <component src="https://c2hbe361.caspio.com/dp/76bfd00052b54e5ba57a4409a861/emb" :is="'script'"></component>
      </div>
    </div>
  </div>
</template>

<script>
import SideBar from './SideBar.vue'

export default {
  name: 'NewCustomer',
  components: {
    SideBar
  }
}
</script>